export enum KeyboardKey {
    Enter = 'Enter'
}
